__turbopack_context__.v({
  "container": "Hmk5NW_container",
  "negative": "Hmk5NW_negative",
  "text": "Hmk5NW_text",
});
